import { render, staticRenderFns } from "./showAllQuestions.vue?vue&type=template&id=216e63b2&scoped=true&"
import script from "./showAllQuestions.vue?vue&type=script&lang=js&"
export * from "./showAllQuestions.vue?vue&type=script&lang=js&"
import style0 from "./showAllQuestions.vue?vue&type=style&index=0&id=216e63b2&prod&lang=scss&scoped=true&"
import style1 from "./showAllQuestions.vue?vue&type=style&index=1&id=216e63b2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216e63b2",
  null
  
)

export default component.exports